const Start = [
  {
    heroTitle: "Toman And Tether Markets",
    subTitle:
      'What is the difference between different markets in "coinnik Market"?',
    body: [
      "In Toman markets, you can buy and sell digital currency by paying Toman (and in Toman).",
      "In Toman markets, you can buy and sell digital currency by paying tetra (each tetra is equal to 1 dollar).",
      "In each of these markets, when you enter, you will see the price of your desired digital currency according to it.",
      " If you want to buy in Tetri market. First, convert your money into Tetr / Toman in the market.",
      "Then you can buy in Tetri market.",
      "It is clear that after selling the currency code in the Tetri market, your balance will also turn into Tetra.",
    ],
    content:
      "Now you can buy and sell your desired currency code in Tetri or Toman market.",
    firstContent: "Choose_for_your_trades",
    video: "https://www.aparat.com/video/video/embed/videohash/5SFYo/vt/frame",
  },
  {
    heroTitle: "Buy and sell digital currency",
    subTitle: 'How to do digital currency trading in "coinnik Market"?',
    content:
      "By knowing and researching the code of the currencies you invest in; You will have profitable deals.",
    body: [
      "Choose one of the Toman / Tetri markets, then choose the currency code you want.",
      " You enter a trading market where you can place a buy or sell order.",
      "First select your order type (price order / immediate order)",
      "In a price order, you enter the amount and price at which you want to trade.",
      " In an immediate order, there is no need to specify the price and your purchase or sale order will be done at the best price of the moment according to the volume of your order.",
      "In the video on this page, you can see zero percent of a transaction in coinnik Market.",
    ],
    firstContent: "Note_that_in_order",
    video: "https://www.aparat.com/video/video/embed/videohash/fCpug/vt/frame",
  },
  {
    heroTitle: "Order history",
    subTitle: "How can we access our order history at coinnik Market?",
    content:
      "You will probably see a lot of these reports, with the help of these reports you can access the history of your activities in coinnik Market.",
    body: [
      "Enter the history section from the panel menu.",
      "In this section, you can view the history of orders, exchanges, deposits, withdrawals and the history of your login information.",
      "In the order history you can see a list of all your orders, even those that have been canceled or are still being processed.",
      "Exchange history includes a list of trades you have made, whether buying or selling.",
      "In the Deposit History section, you can see the list of deposits, either through the bank portal or as a blockchain, and its status.",
      "In the History of Withdrawals section, you can see the list of withdrawals, both in toman and blockchain withdrawals, and its status.",
      "The history of the login section is at your fingertips to know the IP and devices with which you have accessed your account.",
    ],
    firstContent: "Exchanges_trades",
    video: "https://www.aparat.com/video/video/embed/videohash/2lHSK/vt/frame",
  },
];
export default Start;
